import * as React from "react";
import { Heading } from "@grandvisionhq/elements";
import { useLink, useLocation } from "@grandvisionhq/frk-routing";
import { Spinner, Alert } from "@grandvisionhq/iris-ui";
import { useIntl, useDispatch, useSelector, uninitState, statusSuccess, statusUninit, statusLoading, statusFailed, statusWarning } from "@grandvisionhq/state";
import { fetchList } from "../../../CCC/actions.js";
import { getCCCSubscriptionList } from "../../../CCC/selectors.js";
import NoSubscriptions from "../../NoSubscriptions/CCC/List/NoSubscriptions/NoSubscriptions.js";
const CCCList = () => {
  const intl = useIntl();
  const { getLabel } = intl;
  const dispatch = useDispatch();
  const list = useSelector(getCCCSubscriptionList) ?? uninitState();
  const cccSubscriptionId = statusSuccess(list) ? list.result[0]?.id ?? "" : "";
  const linkProps = useLink({ route: "me.cccSubscriptions.detail", params: { cccSubscriptionId } });
  const subscriptionDetailPageUrl = linkProps?.href;
  const location = useLocation();
  React.useEffect(() => {
    dispatch(fetchList());
  }, []);
  if (statusUninit(list) || statusLoading(list)) {
    return /* @__PURE__ */ React.createElement(Spinner, { "aria-label": getLabel("common.loadingText") });
  }
  if (statusFailed(list) || statusWarning(list)) {
    return /* @__PURE__ */ React.createElement(
      Alert,
      {
        variant: "error",
        title: intl.getLabel("account.ccc.errors.general"),
        className: "alert-m-default"
      }
    );
  }
  if (statusSuccess(list)) {
    if (list.result.length < 1) {
      return /* @__PURE__ */ React.createElement("div", { className: "subscription-list" }, /* @__PURE__ */ React.createElement(Heading, { variant: "small", component: "h1", className: "subscription-list__title" }, intl.getLabel("account.ccc.list.title")), /* @__PURE__ */ React.createElement(NoSubscriptions, null));
    }
    const { hash } = window.location;
    const url = new URL(`${origin}${subscriptionDetailPageUrl}${hash}`);
    location.replace(url);
  }
  return null;
};
export {
  CCCList,
  CCCList as default
};
//# sourceMappingURL=CCCList.js.map
